<div class="d-flex">
  @if (mandatory === true) {
    <div style="color: red">(*)</div>
  }
  <div class="d-flex align-items-center px-2 py-1 bg-red color-white rounded">
    <i class="mdi mdi-form-select mdi-18px me-1"></i>
    {{ caption }}
  </div>
</div>
